import script from "./energy-details-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./energy-details-page.vue?vue&type=script&setup=true&lang=ts"

import "./energy-details-page.vue?vue&type=style&index=0&id=8828bec2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8828bec2"]])

export default __exports__